export const SCROLL_TOP_TO_CONDENSE_HEADER = 148; // The bottom of the CTA on the search page

export const getCtaBottomPosition = () => {
    const callToActionElement = getCta();
    const headerElement = getHeader();

    if (callToActionElement && headerElement) {
        const isDesktop = window.innerWidth >= 768;
        const bottomPos = callToActionElement.getBoundingClientRect().bottom;
        const headerHeight = headerElement.getBoundingClientRect().height;
        return isDesktop ? bottomPos - headerHeight : bottomPos; // on mobile the header is hidden when scrolling
    }

    return 0;
};

const getCta = () => {
    return document.getElementsByTagName('md-call-to-action')[0];
};

const getHeader = () => {
    return document.getElementsByTagName('header')[0];
};
